import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN = '[VeranstaltungenModul] PostFunkprotokollFallBildEntfernen laden';
export const POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_AUSFUEHREN = '[VeranstaltungenModul] PostFunkprotokollFallBildEntfernen ausführen';
export const POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_ERFOLGREICH = '[VeranstaltungenModul] PostFunkprotokollFallBildEntfernen laden erfolgreich';
export const POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_FEHLER = '[VeranstaltungenModul] PostFunkprotokollFallBildEntfernen Ladefehler';
export const POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunkprotokollFallBildEntfernen nicht ausgeführt (evtl. Offline)';


export class PostFunkprotokollFallBildEntfernenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN;
        constructor(public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildEntfernenAusfuehrenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_AUSFUEHREN;
        constructor(public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildEntfernenErfolgreichAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollIdentifier, public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildEntfernenFehlerAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_FEHLER;
        constructor(public payload: any, public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildEntfernenNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_ENTFERNEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunkprotokollFallBildEntfernenActions =
    PostFunkprotokollFallBildEntfernenAction
    | PostFunkprotokollFallBildEntfernenAusfuehrenAction
    | PostFunkprotokollFallBildEntfernenErfolgreichAction
    | PostFunkprotokollFallBildEntfernenFehlerAction
    | PostFunkprotokollFallBildEntfernenNichtAusgefuehrtAction
    ;
